import React from "react";

/**
 * Telcofy brand button.
 * Spec: rounded-md (6/8px), darker shade on hover, no scale, 150ms transition.
 */
const Button = React.forwardRef(
  (
    { className = "", variant = "primary", size = "md", children, ...props },
    ref
  ) => {
    const variants = {
      primary:
        "bg-brand-500 text-white hover:bg-brand-600 active:bg-brand-700",
      outline:
        "bg-transparent text-brand-600 border border-brand-500 hover:bg-brand-50",
      ghost:
        "bg-transparent text-ink-soft hover:bg-paper-200",
      danger:
        "bg-[#8E1F1F] text-white hover:brightness-95",
    };

    const sizes = {
      sm: "px-3 py-1.5 text-[13px] rounded-md",
      md: "px-4 py-2.5 text-sm rounded-md",
      lg: "px-5 py-3 text-[15px] rounded-md",
    };

    const base =
      "inline-flex items-center justify-center gap-2 font-semibold tracking-tight " +
      "transition-colors duration-150 ease-out " +
      "focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-500/40 focus-visible:ring-offset-2 " +
      "disabled:opacity-50 disabled:cursor-not-allowed";

    return (
      <button
        ref={ref}
        className={`${base} ${variants[variant] || variants.primary} ${sizes[size] || sizes.md} ${className}`}
        {...props}
      >
        {children}
      </button>
    );
  }
);

Button.displayName = "Button";

export default Button;
